import '../ParcoursSante.scss';


export default function SignatureSante() {
    return(
        <></>
    )
}